"use strict";

exports.__esModule = true;
exports.MapPartProcessUserAction = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _MapPartProcessUserActionElement = require("./MapPartProcessUserActionElement");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var MapPartProcessUserAction = exports.MapPartProcessUserAction = {
  name: "MapPartProcess",
  icon: "cog",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "MapPartProcessUserAction.label",
    defaultMessage: "Map Part Process"
  }),
  description: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "MapPartProcessUserAction.description",
    defaultMessage: "Define part Process mapping"
  }),
  requiresContexts: ["device"],
  requiresProps: [],
  components: {
    Element: _MapPartProcessUserActionElement.MapPartProcessActionElement
  }
};